import React from "react"
import styled from "styled-components"
import Slider from "react-slick"
import Title from "../Title"
import StyledSmallTitle from "../styled/styledSmallTitle"
import Paragraph from "../styled/styledParagraph"
import { offer } from "../../data/offer"
import CardOffer from "./CardOffer"

const StyledSection = styled.section`
  padding: 64px 16px calc(100% + 64px);
  background-color: #fffcfa;
  position: relative;
  .slick-track {
    display: flex;
    margin-left: 0;
    .slick-slide {
      width: 242px;
      margin-right: 48px;
    }
  }
  .slick-list {
    padding: 16px 12px;
  }
  .slick-slider {
    width: 100vw;
    margin-top: 16px;
    display: block;
    @media (min-width: 768px) {
      display: none;
    }
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    padding: 80px 16px 325px;
    max-width: 576px;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    grid-template-columns: repeat(4, 1fr);
  }
`

const ContentBox = styled.div`
  @media (min-width: 768px) {
    grid-column: 1 / 3;
  }
  @media (min-width: 1024px) {
    grid-column: 1 / 4;
  }
  @media (min-width: 1200px) {
    grid-column: 1 / 3;
    ${Paragraph} {
      width: 90%;
    }
  }
`

const Offer = () => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
  }
  return (
    <StyledSection id="oferta">
      <ContentBox>
        <StyledSmallTitle>Oferta</StyledSmallTitle>
        <Title>
          <span>Nasze supermoce,</span> <br />
          na miarę cyfrowych superbohaterów.
        </Title>
        <Paragraph>
          Chcesz wyskalować swój biznes? Przyśpieszyć rozwój swojej firmy? A
          może chciałbyś wprowadzić na rynek zupełnie nowy innowacyjny
          produkt? Niezależnie od Twoich intencji i pomysłów, jesteśmy w
          stanie Ci pomóc osiągnąć sukces.
        </Paragraph>
      </ContentBox>
      {offer.map(item => (
        <CardOffer {...item} key={item.title} className="card-pc" />
        ))}
      <Slider {...settings}>
        {offer.map(item => (
          <CardOffer {...item} key={item.title} />
          ))}
      </Slider>
    </StyledSection>
  )
}

export default Offer
